import React from 'react'
import { Col, Row } from 'antd'
import { FormikProps } from 'formik'

import { Policy, PolicyApprovalRules } from 'src/types'
import { Select } from 'src/components/Formik'

import * as Reduce from './reduces'

interface Props {
  formikProps: FormikProps<PolicyApprovalRules>
  policies: Policy[]
}

export default function SelectPolicyExceptionGroup({
  formikProps,
  policies
}: Props) {
  const generalRulesOptions = policies.reduce(Reduce.generalRules, [])
  const airOptions = policies.reduce(Reduce.air, [])
  const hotelOptions = policies.reduce(Reduce.hotel, [])
  const vehicleOptions = policies.reduce(Reduce.vehicle, [])

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Select
          dataTestId="policy-request-general-rule-id-list"
          formikProps={formikProps}
          label="web.policies.rules.general-rules.title"
          name="policy_request_general_rule_id"
          options={generalRulesOptions}
          placeholder="common.actions.select"
          required={false}
        />
      </Col>
      <Col span={6}>
        <Select
          dataTestId="policy-request-air-rule-id-list"
          formikProps={formikProps}
          label="web.policies.rules.services.title-air"
          name="policy_request_air_rule_id"
          options={airOptions}
          placeholder="common.actions.select"
          required={false}
        />
      </Col>
      <Col span={6}>
        <Select
          dataTestId="policy-request-vehicle-rule-id-list"
          formikProps={formikProps}
          label="web.policies.rules.services.title-hotel"
          name="policy_request_vehicle_rule_id"
          options={hotelOptions}
          placeholder="common.actions.select"
          required={false}
        />
      </Col>
      <Col span={6}>
        <Select
          dataTestId="policy-request-hotel-rule-id-list"
          formikProps={formikProps}
          label="web.policies.rules.services.title-vehicle"
          name="policy_request_hotel_rule_id"
          options={vehicleOptions}
          placeholder="common.actions.select"
          required={false}
        />
      </Col>
    </Row>
  )
}
